import _ from 'lodash';
import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import Popover from '../../../client/components/Popover';
import InfoCirclePng from '../images/info-circle.png';
import InfoCircleSvg from '../images/info-circle.svg';
import styles from './index.sass';

class InfoCircle extends React.Component {
  static propTypes = {
    text: React.PropTypes.string.isRequired,
    style: React.PropTypes.object
  };

  static defaultProps = {
    style: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      popoverIsOpen: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnBodyClick(e) {
    this.setState({popoverIsOpen: false});
  }

  handleOnClickInfoCircleButton(e) {
    this.setState({popoverIsOpen: !this.state.popoverIsOpen});
  }

  render() {
    let popoverBody = <p className={styles.text}>{this.props.text}</p>;
    let popoverProps = {
      body        : popoverBody,
      isOpen      : this.state.popoverIsOpen,
      onBodyClick : this.handleOnBodyClick.bind(this),
      bodyClassName : styles.infoCirclePopoverBody,
      bodyStyle   : {},
      style       : _.extend({
        display: 'inline',
        verticalAlign: 'middle',
        marginLeft: 8
      }, this.props.style)
    };
    let infoCircleButtonProps = {
      className: styles.inforCircleButton,
      style: {
        opacity: this.state.popoverIsOpen ? 1 : 0.3
      },
      onClick: this.handleOnClickInfoCircleButton.bind(this)
    };

    return (
      <Popover {...popoverProps}>
        <button {...infoCircleButtonProps}>
          <img src={InfoCirclePng} srcSet={InfoCircleSvg} />
        </button>
      </Popover>
    );
  }
}

export default InfoCircle;



// WEBPACK FOOTER //
// banquet/components/InfoCircle/index.js